import React, { useState } from 'react';
import Accordian from '../../../utils/accordion'

const ArabicShedule = (props) => {

	// console.log(props?.general_schedule,"schedule");
	// console.log(props?.general_schedule?.schedule_accordions,"schedule");
    let accordions = props?.general_schedule?.schedule_accordions;

	let arabicData = [];
		arabicData = accordions?.map((key, index) => {
			return {
				heading: key.heading,
				content: key.content,
				open: false
			};
		});

	const [arabicAccordions, setArabicAccordions] = useState(arabicData);

    // const [arabicAccordions, setArabicAccordions] = useState([
	// 	{
	// 		heading: `FALL SEMESTER`,
    //         content: `<h3>FALL SEMESTER</h3>
    //         <ul type='none'>
    //         <li>♦ Beginning Arabic 1A (first semester of first-year level)</li>
    //         <li>♦ Intermediate Arabic 2A (first semester of second-year level)</li>
    //         <li>♦ Advanced Arabic 3A (first semester of third-year level)</li>
    //         </ul>`,
	// 		open: false,
	// 	},
	// 	{
	// 		heading: `SPRING SEMESTER`,
	// 		content:` <h3>SPRING SEMESTER</h3>
	// 		<ul type='none'>
	// 			<li>♦ Beginning Arabic 1B (second semester of first-year level)</li>
	// 			<li>♦ Intermediate Arabic 2B (second semester of second-year level)</li>
	// 			<li>♦ Advanced Arabic 3B (second semester of third-year level)</li>
	// 		</ul>`,
	// 		open: false
	// 	},
	// 	{
	// 		heading: `SUMMER INTENSIVE (8 weeks)`,
	// 		content: `<h3>SUMMER INTENSIVE (8 weeks)</h3>
	// 		<ul type='none'>
	// 			<li>♦ Beginning Arabic 1A & 1B (full year of first-year level)</li>
	// 			<li>♦ Intermediate Arabic 2A & 2B (full year of second-year level)</li>
	// 		</ul>`,
	// 		open: false
	// 	}
    // ]);

    return ( 
         <div className='general-schedule' id='general-shedule'>
            {/*<div className='general-heading' >General Schedule</div>*/}
            <div className='general-heading' >{props?.general_schedule?.heading ?? ''}</div>
            <Accordian accordions={arabicAccordions} setAccordions={setArabicAccordions} />
        </div>
);
}

export default ArabicShedule; 